import React from 'react';
import Loader from 'react-loader-spinner';

export default class LoaderMask extends Loader{
	
	render(){
		let type = this.props.type || "Oval";
		return(
			<div className="text-center loadingAnim">
			<Loader 
			type={type}
			color="#00BFFF"
			height="100"	
			width="100"
			/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/common/LoaderMask.js